module.exports = __webpack_public_path__ + "img/ACTIVE_SESSIONS.89ca0445.svg";